import { useContext } from 'preact/hooks';

import { ABTestContext } from './contexts';

export const useAllABTests = () => useContext(ABTestContext);

export const useABTestActiveVariant = (experiment: string) => {
  const allTests = useAllABTests();
  return allTests[experiment];
};
